<div class="rate-agreement-container body-content-area body-data">

    <div class="doughnut-chart-area">
        @for ( info of donutChartInfos; track $index) {
            <div class="rate-agreement-chart doughnut-chart">
                <app-chart [type]="'donut'" [info]="info"></app-chart>
            </div>
        }
    </div>
    <div class="agrrement-list body-data">
        <app-rate-agreement-table [isLandingPage]="true"></app-rate-agreement-table>
    </div>
</div>